import logo from 'assets/logoIcon.png';
import PageHeading from 'components/shared/PageHeading';
import { Col, Container } from 'react-bootstrap';
import Engineer from 'assets/testimonials/enginer.png';
import Insurance from 'assets/testimonials/inusrance.png';
import Mining from 'assets/testimonials/mining.png';
import News from 'assets/testimonials/news.png';
import Property from 'assets/testimonials/property.png';
import Science from 'assets/testimonials/science.png';
import Technology from 'assets/testimonials/technology.png';
import { Swiper } from 'swiper/react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

const Testimonials = () => {
    const breakpoints = {
        640: {
            slidesPerView: 6,
        },
        992: {
            slidesPerView: 6,
        },
    };
    
    return (
        <Container  className='py-5'>
            <div className='d-flex justify-content-center align-items-center text-center pt-5 pb-4'>
                <div>
                    <div className='text-center mb-3 mt-5'>
                        <PageHeading center={true} image={logo} text={"Our Clients"} />
                    </div>
                    <h1>
                        <strong className='px-2'>Industries we've</strong>
                        <i> partnered with</i>
                    </h1>
                    <Col md={8} className='mx-auto '>
                        <p>
                            Discover how Living Wall, based in Perth, combines digital media, spatial transformation, and audio-visual experience to empower brands and communities.
                        </p>
                    </Col>
                </div>
            </div>
            <Swiper
                className="swiper swiper-testi mb-5 mt-3 py-5"
                modules={[Navigation, EffectFade, Autoplay, Pagination]}
                effect="slide"
                speed={1000}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                breakpoints={breakpoints}

            >
                {testimonialsData?.map((sli, index) => (
                    <SwiperSlide key={index}>
                        <div className="d-flex justify-content-center p-3">
                            <img className="img-fluid" src={sli} alt="Testimonials" />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

        </Container>
    );
};

export default Testimonials;

const testimonialsData = [
    Mining,
    Property,
    Engineer,
    News,
    Technology,
    Science,
    Insurance,
];
